import { render, staticRenderFns } from "./GridOperations.vue?vue&type=template&id=10e616aa"
import script from "./GridOperations.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridOperations.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports